import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { Table, Tag, Select, Modal } from "antd";
import AddShift from "../../core/modals/hrm/addshift.jsx";
import EditShift from "../../core/modals/hrm/editshift.jsx";
import withReactContent from "sweetalert2-react-content";
import { API_BASE_URL } from "../../../src/environment";
import { getAllShiftsNew, deleteShift } from "../../service/shiftService.js";
import Swal from "sweetalert2";
import { ArrowLeft } from "lucide-react";
import { UserContext } from "../../context/userContext";
import { hasPermission } from "../../core/json/permissions";

const Shift = () => {
  const { user } = useContext(UserContext);
  const [shiftData, setShifts] = useState([]);
  const [selectedShiftId, setSelectedShiftId] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false);
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize);
  const pageSizeOptions = [1, 2, 3, 5, 10, 20, 50, 100];

  const fetchShifts = async () => {
    setLoading(true);
    try {
      const response = await getAllShiftsNew();
      setShifts(response);
      setSelectedShiftId(null);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching shifts:", error.message);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, []);

  const handleDelete = async (shiftId) => {
    try {
      await deleteShift(shiftId);
      fetchShifts();
    } catch (error) {
      console.error(
        "Error deleting shift:",
        error.response ? error.response.data : error.message
      );
      alert("Error deleting shift!");
    }
  };

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const id = userData?.data?.uid;
  const [userRightssub, setUserRightssub] = useState([]);
  useEffect(() => {
    const fetchUserRightssub = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/userright/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch user rights");
        }
        const data = await response.json();
        console.log("Fetched User Sub Data:", data.data);
        setUserRightssub(data.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        setUserRightssub([]);
      }
    };
    fetchUserRightssub();
  }, [id]);

  const hasJobRightWithAdd = userRightssub.some(
    (right) => right.right === "Shifts" && right.adds === 1
  );

  const columns = [
    {
      title: "Shift Name",
      dataIndex: "shiftName",
      key: "shiftName",
    },
    {
      title: "Shift Type",
      dataIndex: "isFlexibleShift",
      key: "shiftName",
      render: (isFlexibleShift) => (
        <span
          className={`badge ${
            isFlexibleShift ? "badge-linesuccess" : "badge-linesuccess"
          }`}
          style={{ width: 100, padding: 6 }}
        >
          {isFlexibleShift ? "Flexible" : "Non-flexible"}
        </span>
      ),
    },
    {
      title: (
        <>
          Late Grace{" "}
          <span
            style={{ fontSize: "12px", color: "gray", textAlign: "center" }}
          >
            (minutes)
          </span>
        </>
      ),
      dataIndex: "lateGracePeriod",
    },
    {
      title: <div style={{ textAlign: "center" }}>Week Days Definition</div>,
      dataIndex: "weekdaysDefinition",
      key: "weekdaysDefinition",
      render: (weekdaysDefinition) => (
        <div>
          <Table
            dataSource={weekdaysDefinition}
            columns={[
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    Day
                  </Tag>
                ),
                dataIndex: ["day"],
                key: "day",
                align: "left",
              },
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    Checked
                  </Tag>
                ),
                dataIndex: "checked",
                key: "checked",
                align: "left",
                render: (checked) =>
                  checked == true ? (
                    <span className="badge bg-success">Yes</span>
                  ) : (
                    <span className="badge bg-primary">No</span>
                  ),
              },
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    From
                  </Tag>
                ),
                dataIndex: "from",
                key: "from",
                align: "from",
              },
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    To
                  </Tag>
                ),
                dataIndex: "to",
                key: "to",
                align: "left",
              },
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    Shift Hours
                  </Tag>
                ),
                dataIndex: "shiftHours",
                key: "shiftHours",
                align: "left",
              },
            ]}
            pagination={false}
            rowKey="_id"
          />
        </div>
      ),
    },
    {
      title: <div style={{ textAlign: "center" }}>Half Day Definition</div>,
      dataIndex: "halfDayDefinition",
      key: "halfDayDefinition",
      render: (halfDayDefinition) => (
        <div>
          <Table
            dataSource={[halfDayDefinition]}
            columns={[
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    1st Half
                  </Tag>
                ),
                key: "firstHalf",
                children: [
                  {
                    dataIndex: ["firstHalf", "start"],
                    
                    key: "firstHalfStart",
                    align: "left",
                  },
                  {
                    dataIndex: ["firstHalf", "end"],
                    key: "firstHalfEnd",
                    align: "left",
                  },
                ],
              },
              {
                title: (
                  <Tag color="orange" style={{ color: "black" }}>
                    2nd Half
                  </Tag>
                ),
                key: "firstHalf",
                children: [
                  {
                    dataIndex: ["secondHalf", "start"],
                    key: "secondHalfStart",
                    align: "left",
                  },
                  {
                    dataIndex: ["secondHalf", "end"],
                    key: "secondHalfEnd",
                    align: "left",
                  },
                ],
              },
            ]}
            pagination={false}
            rowKey="_id"
          />
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span
          className={`badge ${
            status ? "badge-linesuccess" : "badge-linedanger"
          }`}
          style={{ width: 80, padding: 6 }}
        >
          <Link to="#" style={{ cursor: "default", fontSize: 14 }}>
            {status ? "Active" : "Inactive"}
          </Link>
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <td className="action-table-data">
          <Link
            className="me-2 p-2"
            to="#"
            data-bs-toggle="modal"
            data-bs-target="#edit-units"
            onClick={() => setSelectedShiftId(record._id)}
          >
            <i data-feather="edit" className="feather-edit"></i>
          </Link>
          <Link className="confirm-text p-2" to="#">
            <i
              data-feather="trash-2"
              className="feather-trash-2"
              onClick={() => showConfirmationAlert(record._id)}
            ></i>
          </Link>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (shiftId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(shiftId);
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 };
    setPagination(newPagination);
    setPageSizeModalVisible(false);
  };

  const filteredData = shiftData.filter((item) => {
    const name = item.shiftName ? item.shiftName.toLowerCase() : "";
    return name.includes(search.toLowerCase());
  });

  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container">
                <div>
                  <ArrowLeft size={32} />
                </div>
                <div className="page-title">
                  <h4>Shift</h4>
                  <h6>Manage your employees shift</h6>
                </div>
              </div>
              <div className="page-btn">
                {!hasJobRightWithAdd && (
                  <Link
                    to="#"
                    className={`btn btn-added ${
                      user?.permissions &&
                      hasPermission(user.permissions, "HRM", "Shifts", "create")
                        ? ""
                        : "disabled"
                    }`}
                    data-bs-toggle={
                      !hasJobRightWithAdd &&
                      user?.permissions &&
                      hasPermission(user.permissions, "HRM", "Shifts", "create")
                        ? "modal"
                        : undefined
                    }
                    data-bs-target={
                      !hasJobRightWithAdd &&
                      user?.permissions &&
                      hasPermission(user.permissions, "HRM", "Shifts", "create")
                        ? "#add-units"
                        : undefined
                    }
                    title={
                      !(
                        !hasJobRightWithAdd &&
                        user?.permissions &&
                        hasPermission(
                          user.permissions,
                          "HRM",
                          "Shifts",
                          "create"
                        )
                      )
                        ? "You don't have permission to add shifts"
                        : "Add new shift"
                    }
                  >
                    <PlusCircle className="me-2" />
                    Add New
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="card table-list-card-grid">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="search"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                  <div className="wordset">
                    <style>
                      {`
                                                @media (max-width: 767px) {
                                                    .wordset {
                                                        margin-bottom: 25px !important;
                                                    }
                                                }
                                            `}
                    </style>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="value"
                  pagination={{
                    current: pagination.current,
                    pageSizeOptions: ["1", "2", "5", "10", "20", "50"],
                    total: filteredData.length,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total ${total} items`,
                  }}
                  onChange={handleTableChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddShift onShiftAdded={fetchShifts} />
      <EditShift onShiftAdded={fetchShifts} shiftId={selectedShiftId} />
      <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button
            key="cancel"
            className="btn btn-cancel"
            onClick={() => setPageSizeModalVisible(false)}
          >
            Cancel
          </button>,
          <button
            key="submit"
            className="btn btn-submit"
            onClick={handlePageSizeChange}
          >
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select
            style={{ width: "100%" }}
            value={tempPageSize}
            onChange={(value) => setTempPageSize(value)}
          >
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default Shift;
